import { render, staticRenderFns } from "./XmRejectPicDialog.vue?vue&type=template&id=0672b64f&scoped=true"
import script from "./XmRejectPicDialog.vue?vue&type=script&lang=js"
export * from "./XmRejectPicDialog.vue?vue&type=script&lang=js"
import style0 from "./XmRejectPicDialog.vue?vue&type=style&index=0&id=0672b64f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0672b64f",
  null
  
)

export default component.exports